// app/javascript/controllers/avatar_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["upload", "preview"]

    preview() {
        const file = this.uploadTarget.files[0]
        if (file) {
            // 验证文件类型
            if (!file.type.startsWith("image/")) {
                alert("请选择图片文件")
                return
            }

            // 验证文件大小（5MB）
            if (file.size > 5 * 1024 * 1024) {
                alert("图片大小不能超过5MB")
                return
            }

            const reader = new FileReader()
            reader.onload = (e) => {
                if (this.previewTarget.tagName.toLowerCase() === 'svg' || this.previewTarget.tagName.toLowerCase() === 'div') {
                    // 检查是否是特色图片（32x32）还是头像（12x12）
                    const isFeaturedImage = this.previewTarget.classList.contains('h-32')
                    const img = document.createElement('img')
                    img.src = e.target.result
                    img.alt = isFeaturedImage ? "特色图片" : "Profile Picture"
                    img.classList.add(...(isFeaturedImage ? ['h-32', 'w-32', 'rounded-lg', 'bg-gray-700', 'object-cover'] : ['h-12', 'w-12', 'rounded-full']))
                    img.dataset.avatarTarget = 'preview'
                    this.previewTarget.replaceWith(img)
                    this.previewTarget = img
                } else {
                    this.previewTarget.src = e.target.result
                }
            }
            reader.readAsDataURL(file)
        }
    }

    remove() {
        // 检查是否是特色图片还是头像
        const isFeaturedImage = this.element.querySelector('.h-32')

        if (isFeaturedImage) {
            // 特色图片移除
            this.previewTarget.innerHTML = `
                <svg class="h-16 w-16 text-gray-500" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 3a3 3 0 00-3 3v12a3 3 0 003 3h18a3 3 0 003-3V6a3 3 0 00-3-3H3z" clip-rule="evenodd" />
                    <path fill-rule="evenodd" d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 3a3 3 0 00-3 3v12a2.25 2.25 0 003 3h18a3 3 0 003-3V6a3 3 0 00-3-3H3z" clip-rule="evenodd" />
                    <path d="M3 6a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 6z" />
                </svg>
            `
        } else {
            // 头像移除
            this.previewTarget.innerHTML = `
                <svg class="h-12 w-12 text-gray-500" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M18.685 19.097A9.723 9.723 0 0021.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 003.065 7.097A9.716 9.716 0 0012 21.75a9.716 9.716 0 006.685-2.653zm-12.54-1.285A7.486 7.486 0 0112 15a7.486 7.486 0 015.855 2.812A8.224 8.224 0 0112 20.25a8.224 8.224 0 01-5.855-2.438zM15.75 9a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" clip-rule="evenodd"></path>
                </svg>
            `
        }

        // 清空文件输入
        this.uploadTarget.value = ""

        // 隐藏移除按钮
        const removeButton = this.element.querySelector('[data-action*="remove"]')
        if (removeButton) {
            removeButton.style.display = 'none'
        }
    }
}